import { render, staticRenderFns } from "./AlertsConfiguration.vue?vue&type=template&id=2a742b66&scoped=true"
import script from "./AlertsConfiguration.ts?vue&type=script&lang=ts&external"
export * from "./AlertsConfiguration.ts?vue&type=script&lang=ts&external"
import style0 from "./AlertsConfiguration.vue?vue&type=style&index=0&id=2a742b66&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a742b66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a742b66')) {
      api.createRecord('2a742b66', component.options)
    } else {
      api.reload('2a742b66', component.options)
    }
    module.hot.accept("./AlertsConfiguration.vue?vue&type=template&id=2a742b66&scoped=true", function () {
      api.rerender('2a742b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Alerts/pages/AlertsConfiguration/AlertsConfiguration.vue"
export default component.exports